// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.8.2';
//# sourceMappingURL=version.js.map